import { useState, type FormEvent } from 'react';
import { APP_VERSION_LABEL } from '@pmis/shared';
import { errorMessage } from '../lib/api';
import { AUTH_METHODS, AUTH_MODE, useAuth } from '../lib/auth';
import { Alert, Button, Field, Input, Logo } from '../components/ui';
import { Icon } from '../components/pmis';

const DEV_USERS: [string, string][] = [
  ['admin@dev.local', 'Administrador'], ['pmo@dev.local', 'PMO'], ['gerente@dev.local', 'Gerente de projetos'],
  ['engenheiro@dev.local', 'Engenharia'], ['financeiro@dev.local', 'Financeiro'], ['diretoria@dev.local', 'Diretoria'],
];

export function LoginPage({ notice }: { notice?: string }) {
  const { loginPassword, loginEntra, loginDev } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try { await loginPassword(email, password); } catch (err) { setError(errorMessage(err)); } finally { setBusy(false); }
  };
  return (
    <div className="grid min-h-full place-items-center p-4">
      <div className="w-full max-w-md">
        <div className="mb-6 flex items-center gap-3">
          <Logo className="h-9" />
          <span className="border-l border-line pl-3 text-lg font-semibold">PMIS</span>
        </div>
        <div className="rounded-2xl border border-line bg-panel p-6 shadow-xl">
          <h1 className="text-xl font-semibold">Gestão de projetos da AD Digital</h1>
          <p className="mt-1 text-sm text-muted">Painel, projetos, diário, cronograma, horas, custos e reuniões num só lugar.</p>
          {notice ? <Alert className="mt-4">{notice}</Alert> : null}
          {error ? <Alert tone="err" className="mt-4">{error}</Alert> : null}
          {AUTH_METHODS.entra ? (
            <Button variant="primary" className="mt-5 h-11 w-full text-base" onClick={() => void loginEntra()}>
              <svg viewBox="0 0 21 21" className="size-4" aria-hidden><path fill="#f25022" d="M1 1h9v9H1z" /><path fill="#7fba00" d="M11 1h9v9h-9z" /><path fill="#00a4ef" d="M1 11h9v9H1z" /><path fill="#ffb900" d="M11 11h9v9h-9z" /></svg>
              Entrar com a conta Microsoft
            </Button>
          ) : null}
          {AUTH_METHODS.password ? (
            <form onSubmit={submit} className="mt-5 space-y-3">
              {AUTH_METHODS.entra ? <div className="text-center text-xs text-muted">ou, se o administrador liberou, com e-mail e senha</div> : null}
              <Field label="E-mail"><Input type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required /></Field>
              <Field label="Senha"><Input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required /></Field>
              <Button type="submit" variant={AUTH_METHODS.entra ? 'secondary' : 'primary'} className="w-full" disabled={busy}>{busy ? 'Entrando…' : 'Entrar'}</Button>
            </form>
          ) : null}
          {AUTH_MODE === 'dev' ? (
            <div className="mt-6 border-t border-line pt-4">
              <div className="mb-2 flex items-center gap-2 text-xs font-medium text-warn"><Icon name="shield" className="size-4" />Desenvolvimento: entrar como</div>
              <div className="grid grid-cols-2 gap-2">
                {DEV_USERS.map(([e, label]) => (
                  <Button key={e} size="sm" onClick={() => void loginDev(e).catch((err) => setError(errorMessage(err)))} data-testid={`dev-${e.split('@')[0]}`}>{label}</Button>
                ))}
              </div>
            </div>
          ) : null}
        </div>
        <p className="mt-4 text-center text-xs text-muted">PMIS ADD · versão {APP_VERSION_LABEL} · acesso restrito à equipe da AD Digital</p>
      </div>
    </div>
  );
}

export function MustChangePasswordPage() {
  const { changePassword, logout } = useAuth();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [error, setError] = useState<string | null>(null);
  return (
    <div className="grid min-h-full place-items-center p-4">
      <form className="w-full max-w-md space-y-3 rounded-2xl border border-line bg-panel p-6" onSubmit={async (e) => {
        e.preventDefault();
        try { await changePassword(current, next); } catch (err) { setError(errorMessage(err)); }
      }}>
        <h1 className="text-lg font-semibold">Troque a senha provisória</h1>
        <p className="text-sm text-muted">Use pelo menos 10 caracteres. A senha não pode conter o seu e-mail.</p>
        {error ? <Alert tone="err">{error}</Alert> : null}
        <Field label="Senha provisória"><Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required /></Field>
        <Field label="Nova senha"><Input type="password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} required /></Field>
        <div className="flex gap-2"><Button type="submit" variant="primary">Trocar e entrar</Button><Button onClick={logout}>Sair</Button></div>
      </form>
    </div>
  );
}
